export const ZINDEX = {
  modal: 15,
  fullScreenModal: 14,
};
